import { array, boolean, type ObjectSchema, string, object } from 'yup';

import { phoneTypes } from '@/constants/memberContactInfo';
import type { Person } from '@/types/person';

export const phoneNumbersSchema: ObjectSchema<Pick<Person, 'phones'>> = object({
  phones: array()
    .of(
      object().shape({
        id: string().optional().label('Phone id'),
        default: boolean().required().label('Default'),
        number: string()
          .trim()
          .max(15, 'Phone number is too long')
          .matches(
            /^(?:[+][0-9])?[(]?[0-9]{3}[)]?[-]?[0-9]{3}[-]?[0-9]{4}$/,
            'Phone number is not valid'
          )
          .required(),
        kind: string().oneOf(phoneTypes).required().label('Phone number kind'),
        _delete: boolean().optional()
      })
    )
    .required()
    .test(
      'moreThanOneDefault',
      "You can't have more than one default phone. Please uncheck one default.",
      (phones) => {
        if (phones) {
          return !(phones.filter((phone) => phone.default && !phone._delete).length > 1);
        }

        return true;
      }
    )
    .test('atLeastOneDefault', 'One phone number must be marked as default.', (phones) => {
      if (!phones) return true;
      const remaining = phones.filter((phone) => !phone._delete);
      if (remaining.length === 0) return true;
      return remaining.some((phone) => phone.default);
    })
});
